<template>
  <div>
    <div v-if="!rawsrc">
      Loading...
    </div>
    <div v-if="rawsrc">
      <b-alert variant="danger" v-if="hasDuplicateLayers" class="m-1">
        WARNING: This template appears to have duplicate layers
      </b-alert>
      <b-table-simple >
        <b-tr>
          <b-td>Width</b-td>
          <b-td class="text-right">
            {{ size.width }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Height</b-td>
          <b-td class="text-right">
            {{ size.height }}
          </b-td>
        </b-tr>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      rawsrc: null,
    };
  },

  computed: {
    size() {
      if (!this.rawsrc) {
        return { width: null, height: null };
      }

      let maxWidth = 0;
      let maxHeight = 0;
      let minWidth = 10000000000;
      let minHeight = 10000000000;
      const lines = this.rawsrc.split('\n');

      lines.forEach((line) => {
        if (line.startsWith('M') || line.startsWith('D')) {
          const coords = line.replace('M', '').replace('D', '').trim().split(',');
          const c1 = coords[0] * 1;
          const c2 = coords[1] * 1;
          // eslint-disable-next-line no-restricted-globals
          if (!isNaN(c1) && coords[0] !== '') { // when coords[0] == "" == 0 which sets the min to 0
            maxWidth = Math.max(maxWidth, c1);
            minWidth = Math.min(minWidth, c1);
          }
          // eslint-disable-next-line no-restricted-globals
          if (!isNaN(c2) && coords[1] !== '') { // when coords[0] == "" == 0 which sets the min to 0
            maxHeight = Math.max(maxHeight, c2);
            minHeight = Math.min(minHeight, c2);
          }
        }
      });

      return ({
        // Math.floor to do same rounding as cutting algorithm
        // Divide by 20 for GPGL
        width: ((Math.floor(maxWidth * 2) - Math.floor(minWidth * 2)) / 40),
        height: ((Math.floor(maxHeight * 2) - Math.floor(minHeight * 2)) / 40),
      });
    },

    hasDuplicateLayers() {
      if (!this.rawsrc) {
        return false;
      }

      const commands = this.rawsrc.split(';');
      const segments = [];
      let currentSegment;

      commands.forEach((command) => {
        if (command.startsWith('PU')) {
          if (currentSegment) {
            segments.push(currentSegment);
          }
          currentSegment = { instructions: [], coords: [] };
          const coords = command.replace('PU', '').split(',');
          currentSegment.coords.push(coords);
          currentSegment.instructions.push(command);
        }
        if (command.startsWith('PD')) {
          const coords = command.replace('PD', '').split(',');
          currentSegment.coords.push(coords);
          currentSegment.instructions.push(command);
        }
      });
      if (currentSegment) {
        segments.push(currentSegment);
      }
      return segments.some((s1) => segments.some((s2) => (s2.instructions.join('') === s1.instructions.join('') && (s2 !== s1))));
    },
  },

  created() {
    if (this.src) {
      fetch(`https://cdn.gokaizen.com/${this.src}`).then((resp) => resp.text()).then((text) => {
        this.rawsrc = text;
      });
    }
  },
};
</script>
